import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import Label from './NavMenuLabel';
import { fireMessageEvent } from '../messenger/utils';
import { analyticActionMap } from '../analytics/utils';

const disabledLinkStyles = ({ isDisabled }) =>
  isDisabled &&
  css`
    pointer-events: none;
  `;

const StyledListItem = styled('li')(disabledLinkStyles);

const baseLinkStyles = ({ theme }) => css`
  color: ${theme.colors.white};
  opacity: 0.6;
  transition: color 0.1s ease-in;
  text-decoration: none;
  padding: ${theme.spacings.byte};
  display: block;
`;

const activeLinkStyles = ({ theme, isDisabled }) =>
  !isDisabled &&
  css`
    &.active {
      opacity: 1;
      color: ${theme.colors.white};
      text-decoration: underline !important;
      text-decoration-color: white !important;
      -webkit-text-decoration-color: white;
      text-decoration-style: solid;
      text-underline-offset: 5px;
    }
  `;
const StyledLink = styled(NavLink)(baseLinkStyles, activeLinkStyles);
const NavMenuItem = ({ routeId, label, path, search, isDisabled, handleLinkClick, navigationGuard }) => {
  const { config, routing } = useSelector((state) => state);
  const { platform, env } = config;
  const { currentRoute } = routing;

  const handleNavMenuItemClick = (e) => {
    if (navigationGuard?.hasPartialPicks && currentRoute === 'playNow' && routeId !== 'playNow') {
      e.preventDefault();
      navigationGuard.handleNavigationAttempt(routeId);
      return;
    }

    const { history, leaderboard, gameInfo, playNow, path, clickedType, tabType } = analyticActionMap;
    let name;
    switch (routeId) {
      case 'history':
        name = history;
        break;
      case 'leaderboard':
        name = leaderboard;
        break;
      case 'gameInfo':
        name = gameInfo;
        break;
      case 'playNow':
        name = playNow;
        break;
    }

    fireMessageEvent({
      platform,
      env,
      title: clickedType,
      data: { path, element: tabType, element_name: name },
    });
    handleLinkClick(routeId);
  };
  return (
    <StyledListItem isDisabled={isDisabled}>
      <StyledLink to={`${path}${search}`} onClick={handleNavMenuItemClick} end>
        <Label as='span' size='giga'>
          {label}
        </Label>
      </StyledLink>
    </StyledListItem>
  );
};

NavMenuItem.propTypes = {
  routeId: PropTypes.string,
  location: PropTypes.object,
  isDisabled: PropTypes.bool,
  label: PropTypes.string,
  path: PropTypes.string,
  handleLinkClick: PropTypes.func,
};

export default NavMenuItem;
